export default function pdp(state = {}, action) {
  switch (action.type) {
    case 'SET_SELECTED_PRODUCT_PDP': {
      const selectedProduct = action.payload.product
      let selectedVariant = action.payload.variant
      // Set a default variant when there is only one available
      // for the selectedProduct (i.e. backpack)
      if (!selectedVariant && selectedProduct.variants.length === 1) {
        selectedVariant = selectedProduct.variants[0]
      }
      return {
        ...state,
        selectedProduct,
        selectedVariant,
      }
    }

    case 'SET_SELECTED_VARIANT_PDP': {
      return {
        ...state,
        selectedVariant: action.payload.variant,
      }
    }

    case 'SET_PURCHASE_AREA_ENTERED_OR_LEFT': {
      return { ...state, purchaseAreaVisible: action.payload }
    }

    case 'SET_SELECTED_VARIANT_SIZE': {
      return { ...state, selectedVariantSize: action.payload.variant.size }
    }

    default:
      return state
  }
}
